import { apiOku } from "./api.js";
import type { Urun } from "./kancalar.js";

const SAYFA_BOYUTU = 500;

/** Seçim ve barkod araması ilk sayfayla sınırlı kalmasın. */
export async function urunListesiniOku(
  aktif?: boolean,
  limit?: number,
): Promise<{ urunler: Urun[] }> {
  const urunler: Urun[] = [];
  for (let offset = 0; ; offset += SAYFA_BOYUTU) {
    const sayfa = await apiOku<{ urunler: Urun[] }>("/urun", {
      aktif,
      limit: limit ?? SAYFA_BOYUTU,
      offset,
    });
    urunler.push(...sayfa.urunler);
    if (limit !== undefined || sayfa.urunler.length < SAYFA_BOYUTU) {
      return { urunler };
    }
  }
}
